import { ProductName } from 'shared/interfaces/Product';
import { CaldotcomCheckAvailabilityToolConfig } from 'shared/interfaces/tools/caldotcom/CaldotcomCheckAvailability';
import { CaldotcomScheduleMeetingToolConfig } from 'shared/interfaces/tools/caldotcom/CaldotcomScheduleMeeting';
import { CalendlyToolConfig } from 'shared/interfaces/tools/Calendly';
import { CallTransferToolConfig } from 'shared/interfaces/tools/CallTransfer';
import { CollectLeadInfoToolConfig } from 'shared/interfaces/tools/CollectLeadsInfo';
import { CompleteEmailHandoffToolConfig } from 'shared/interfaces/tools/CompleteEmailHandoff';
import { CustomApiRequestToolConfig } from 'shared/interfaces/tools/CustomApiRequest';
import { EmailHandoffToolConfig } from 'shared/interfaces/tools/EmailHandoff';
import { FollowUpToolConfig } from 'shared/interfaces/tools/FollowUp';
import { TakeoverRequestToolConfig } from 'shared/interfaces/tools/TakeoverRequest';

export type ToolConfig =
  | CollectLeadInfoToolConfig
  | CalendlyToolConfig
  | EmailHandoffToolConfig
  | TakeoverRequestToolConfig
  | CompleteEmailHandoffToolConfig
  | CaldotcomCheckAvailabilityToolConfig
  | CaldotcomScheduleMeetingToolConfig
  | CallTransferToolConfig
  | FollowUpToolConfig
  | CustomApiRequestToolConfig;

export interface BaseToolConfig {
  _id?: string; // If _id is provided, the tool config is already saved
  kind: ToolKind;
  toolName: string;
  trigger: ToolTrigger;
  enabled: boolean;
}

export interface ToolGroup extends StaticToolGroup {
  toolConfigs: ToolConfig[];
}

export interface StaticToolGroup {
  displayName: string;
  displayDescription: string;
  toolKinds: ToolKind[];
  icon: React.ReactNode;
  kind: ToolGroupKind;
  minProduct: ProductName;
}

export enum ToolGroupKind {
  LEAD_COLLECTION = 'lead-collection',
  CALENDLY = 'calendly',
  EMAIL_HANDOFF = 'email-handoff',
  TAKEOVER_REQUEST = 'takeover-request',
  CALDOTCOM_APPOINTMENT_SCHEDULING = 'caldotcom-appointment-scheduling',
  CALL_TRANSFER = 'call-transfer',
  FOLLOW_UP = 'follow-up',
  CUSTOM_API_REQUEST = 'custom-api-request'
}

export enum ToolKind {
  COLLECT_LEAD_INFO = 'collectLeadInfo',
  CALENDLY = 'calendly',
  EMAIL_HANDOFF = 'emailHandoff',
  COMPLETE_EMAIL_HANDOFF = 'completeEmailHandoff',
  SHOPIFY_PRODUCT_KNOWLEDGE = 'shopifyProductKnowledge',
  SHOPIFY_STORE_KNOWLEDGE = 'shopifyStoreKnowledge',
  TAKEOVER_REQUEST = 'takeoverRequest',
  CALDOTCOM_CHECK_AVAILABILITY = 'caldotcomCheckAvailability',
  CALDOTCOM_SCHEDULE_MEETING = 'caldotcomScheduleMeeting',
  CALL_TRANSFER = 'callTransfer',
  FOLLOW_UP = 'followUp',
  CUSTOM_API_REQUEST = 'customApiRequest'
}

export enum ToolTrigger {
  WELCOME = 'WELCOME',
  FIRST_SMART_ASSISTANT_MESSAGE = 'FIRST_SMART_ASSISTANT_MESSAGE',
  BUTTON = 'BUTTON',
  INTENT = 'INTENT',
  FORCED = 'FORCED',
  SCHEDULED = 'SCHEDULED'
}

export interface UpdateAllToolConfigsDto {
  smartAssistantId: string;
  toolConfigs: ToolConfig[];
}
